module.exports = __webpack_public_path__ + "img/man-made-material.f965980c.svg";